import store from "@/store";
import weuijs from 'weui.js'

export default function (bus) {
  /*
* loading
* */
  window.requestLoading = null;
  let requestLoadingQueue = [];
  window.requestHide = null;
  bus.$on('requestLoading', (data) => {
    if (data === false) {
      console.log('requestLoadingQueue', data);
      requestLoadingQueue.shift();
      if (requestLoadingQueue.length === 0) {
        if (window.requestHide) clearTimeout(window.requestHide);
        window.requestHide = setTimeout(() => {
          window.requestLoading.hide();
          store.commit('setRequestLoading', false);
          window.requestLoading = null;
        }, 300);
      }
    } else {
      requestLoadingQueue.push(data);
      console.log('requestLoadingQueue', requestLoadingQueue);
      if (window.requestHide) clearTimeout(window.requestHide);
      window.requestHide = null;
      if (!requestLoading) {
        store.commit('setRequestLoading', true);
        window.requestLoading = weuijs.loading('加载中...');
      } else {

      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/lib/requestLoading.js